module.exports = __webpack_public_path__ + "img/calendar.2.bc4e06c7.svg";